<template>
  <div class="summary-container">
    <div class="summary">
      <h2>Pay Deposit</h2>
      <div v-show="activeIndex == 0">
        <div>
          <h4>Pay Initial Deposit</h4>
          <i style="fontSize: 14px; font-weight:bold; color: red"
            >NB: Card used for payment would be set as default for recurring
            payments!</i
          >
          <lo-mini-tracker
            :tabItems="tabItems"
            :activeIndex="activeIndex"
            ref="progressTracker"
          />
          <form>
            <div class="kyc-row">
              <div class="first">
                <h4>First Name</h4>
                <input-field :model="getUserSession.firstname" disabled />
              </div>
              <div class="first">
                <h4>Last Name</h4>
                <input-field :model="getUserSession.lastname" disabled />
              </div>
            </div>

            <h4>Email Address</h4>
            <input-field :model="getUserSession.email" disabled />

            <p style="margin-bottom: 20px;">
              Paying Now
              <span class="amount">
                NGN
                {{ firstpaymentamt }}
              </span>
            </p>
          </form>
          <div v-if="loader" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
            <button
              @click="flutterwavePaygate"
              class="download-button"
              type="button"
            >
              Make Payment
            </button>
          </div>
        </div>
      </div>

      <modal-verify
        v-if="showModalValidated"
        @close="showModalValidated = false"
      ></modal-verify>

      <consent
        @consent="consent"
        v-if="showChoice"
        @close="showChoice = false"
      ></consent>

      <table-modal
        :tableDatas="tableDatas"
        v-if="showTable"
        @close="closeTable"
        @closeCon="showChoice = false"
      ></table-modal>

      <div v-show="activeIndex == 1">
        <h4>Set Re-occuring Billing</h4>
        <i style="fontSize: 12px; marginLeft: 25%;"
          >NB: Default card would be colored blue!</i
        >
        <lo-mini-tracker
          :tabItems="tabItems"
          :activeIndex="2"
          ref="progressTracker"
        />

        <h4 style="marginTop: 50px; marginBottom: 0px;">Select Default Card</h4>

        <div>
          <template v-if="paymentSucess">
            <el-alert
              title="Successful Payment"
              center="true"
              type="success"
              description="Your payment was successful!"
              show-icon
            >
            </el-alert
          ></template>
        </div>

        <div class="card-section">
          <div
            v-for="(card, index) in debitCards"
            :key="index"
            class="single-card"
          >
            <div
              @click="setDefaultCard(card.id, card.customerid)"
              :class="
                card.isDefaultCard ? 'debit-cards' : 'debit-cards-inactive'
              "
            >
              <p>{{ card.firstname }} {{ card.lastname }}</p>
              <h2>{{ "**** **** **** " + card.last4digits }}</h2>
              <p>
                {{
                  card.cardtype.charAt(0).toUpperCase() +
                    card.cardtype.substr(1).toLowerCase()
                }}
                {{ card.expirymonth + "/" + card.expiryyear }}
              </p>
            </div>
          </div>
        </div>
        <div>
          <button
            @click="flutterwavePaygate('10')"
            class="download-button"
            type="button"
          >
            Add a Debit Card
          </button>
        </div>
      </div>
    </div>
    <div class="illustration">
      <div class="description">
        We value the security of your card. Please note that your details will
        be tokenized, encrypted, and processed following the PCI Data Security
        Standards
      </div>
      <img
        :src="require('../../../../assets/img/polygon.svg')"
        class="polygon"
        alt="Comment Bubble"
      />
      <img :src="require('../../../../assets/img/man-woman.png')" alt="" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import InputField from "../components/InputField.vue";
import LoMiniTracker from "../components/LoMiniTracker.vue";
import ModalSucess from "../../kitchen/Onboarding/ModalSuccess.vue";
import ModalVerify from "../../kitchen/Onboarding/modal-verify.vue";

import axios from "axios";
import VueSweetalert2 from "vue-sweetalert2";
import Cookie from "js-cookie";
import Rave from "vue-ravepayment";
import Consent from "../../kitchen/Onboarding/Consent.vue";
import TableModal from "../../kitchen/Onboarding/TableModal.vue";
import Vue from "vue";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
// Vue.forceUpdate();

export default {
  name: "PayDeposit",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  components: {
    InputField,
    VueSweetalert2,
    TableModal,
    ModalVerify,
    ModalSucess,
    Consent,
    Rave,
    LoMiniTracker
  },
  computed: {
    ...mapGetters([
      "getUserAmount",
      "getCustomerProductOptions",
      "getUserSession"
    ]),
    genRandomNumber() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  },
  data() {
    return {
      showModalValidated: false,
      newCardFormVisible: true,
      loader: false,
      showWarnMsg: "",
      info: {},
      card: {
        number: "",
        expiry: "",
        cvv: "",
        pin: ""
      },
      debitCards: [],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      processCard: false,
      defaultCardSet: false,
      defaultCardID: "",
      formErrors: {},
      // fieldTypes: {
      //   password: 'text'
      // },
      loader1: false,
      custProdOptions: {},
      firstpaymentamt: "",
      meta: [
        {
          metaname: "school",
          metavalue: "high school"
        }
      ],
      tableDatas: null,
      paymentSucess: false,
      exactName: localStorage.exactName,
      showChoice: false,
      showTable: false,
      messageSuccess: "Your payment was successful!",
      modalSucess: false,
      activeIndex: 0,
      exact: this.getUserAmount,
      exactRepay: Cookie.get("amtRepay") ? Cookie.get("amtRepay") : "",
      exactTenure: localStorage.tenure,
      active: "Arnergy 5000",
      raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      redirectUrl: "/onboarding",
      formData: {
        paymentDay: "",
        startingDate: "01/02/2020",
        amountPay: ""
      },
      packages: [
        { id: 1, name: "Arnergy 5000", amount: 500 },
        { id: 2, name: "Arnergy 5000X", amount: 2500 },
        { id: 3, name: "Arnergy 10000", amount: 5000 }
      ],
      counter: 0,
      tabItems: [
        {
          title: "Pay Deposit",
          percent: "0"
        },
        {
          title: "Set Re-occuring Billing",
          percent: "100"
        }
      ]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    ...mapActions(["setUserSession"]),
    toggleNewCardForm() {
      this.newCardFormVisible = !this.newCardFormVisible;
    },
    addDebitCard() {
      this.formErrors = this.validateInputs();
      console.log(this.formErrors);
      console.log("card", this.card);
      if (Object.keys(this.formErrors).length > 0) return;

      const hello = this.card;
      console.log(hello);
    },
    endCardProcessing() {
      this.processCard = false;
      this.defaultCardSet = false;
      this.modalSucess = false;
    },
    updateExpiryInput(expiry) {
      if (expiry.length === 2) this.card.expiry = expiry + " / ";
      else if (expiry.length > 2) {
        const x = expiry.replace(" / ", "");
        if (x.length === 3) this.card.expiry = `${x[0]}${x[1]} / ${x[2]}`;
        this.card.expiry = `${x[0]}${x[1]} / ${x[2]}${x[3]}`;
        console.log(this.card.expiry);
      }
    },
    gotoSection(value) {
      this.activeIndex = value;
    },
    getAmount() {
      const active = this.packages.find(item => item.name == this.active);
      return active.amount;
    },
    close() {
      console.log("Payment closed");
    },
    triggerPayment() {
      document.getElementById(`paymentbtn`).click();
    },
    validateInputs() {
      const formErrors = [];

      for (let [field, value] of Object.entries(this.card)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "number":
            console.log(Number(value));
            console.log(typeof Number(value));
            if (value === "null" || value === "") {
              formErrors[field] = "Number cannot be empty.";
            } else if (value.length < 16 || value.length > 18) {
              formErrors[field] = "Card number length is incorrect";
            } else if (isNaN(value)) {
              formErrors[field] = "Please enter a valid card number.";
            }
            break;
          case "expiry":
            console.log(value.replace(" / ", ""));
            if (value === "null" || value === "") {
              formErrors[field] = "Expiry cannot be empty.";
            } else if (
              value.replace(" / ", "").length < 4 ||
              value.replace(" / ", "").length > 4
            ) {
              formErrors[field] = "Invalid date entered";
            } else if (isNaN(value.replace(" / ", ""))) {
              formErrors[field] = "Please enter a valid expiry date.";
            }
            break;
          case "cvv":
            if (value === "null" || value === "") {
              formErrors[field] = "CVV cannot be empty.";
            } else if (value.length < 3 || value.length > 3) {
              formErrors[field] = "CVV should be 3 characters";
            } else if (isNaN(value.replace(" / ", ""))) {
              formErrors[field] = "Please enter a valid CVV.";
            }
            break;
          default:
            break;
        }
      }
      return formErrors;
    },
    callback: function(response) {
      let trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      this.close();
      if (trRef.data.status === "successful") {
        this.showSuccessMsg = { message: "Transaction Successful!" };
      } else {
        this.showErrorMsg({ message: "Transaction fails" });
      }
    },
    setCurrentAfterPayment() {
      this.$emit("showLoading", true);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      const txref = params["tx_ref"];

      if (!txref) {
        this.$emit("showLoading", false);
        return;
      }
      const data = {
        txref: txref
      };

      const HTTP = this.$httpUtils.FASTHTTP;
      HTTP.post("/payment/verify-payment", data)
        .then(res => {
          console.log("testing", res.data);
          this.activeIndex = 1;
          if (res.data) {
            window.history.replaceState(
              null,
              "Arnergy :: IOT",
              "/onboarding/lo"
            );
            localStorage.recurID = res.data.id;

            this.modalSucess = true;
            this.updateStateFunc();
            this.fetchDebitCards(this.getUserSession.id);
            this.activeIndex = 1;
            this.$emit("showLoading", false);
          } else {
            console.log("Nothing to show here");
          }
        })
        .catch(error => {
          console.log("testing error", error);
          console.log(error);
          this.$emit("showLoading", false);
        });
    },
    updateStateFunc() {
      console.log("presssed");
      const payloadData = {
        stateid: v
      };
      const HTTP = this.$httpUtils.FASTHTTP;
      HTTP.patch("/onboardingstate/nextstate", payloadData).then(res => {
        this.$store.commit("saveOnboanrdingState", v);

        if (res.data) {
          // this.showAgreement = false
        }
      });
    },

    showAlert() {
      // Use sweetalert2
      this.$swal.fire({
        title: "Success",
        imageWidth: "40px",
        text: "Your payment was successful",
        icon: "success",
        width: "550px"
      });
    },
    async verify() {
      const data = {
        txref: localStorage.txf_ref
      };

      const HTTP = this.$httpUtils.FASTHTTP;

      try {
        let res = await HTTP.post("/payment/verify-payment", data);
        // this.$emit("showLoading", false);

        if (res.data.customerid && res.status == 200) {
          localStorage.recurID = res.data.id;
          this.activeIndex == 1;
          this.modalSucess = true;
          console.log("activeee", this.activeIndex);
          return;
        }

        if (res.data == null || res.status == 204) {
          this.showModalValidated = true;
        }
      } catch (error) {
        this.showModalValidated = true;
        setTimeout(() => {
          window.location.href = "/onboarding/lo";
        }, 3900);

        console.log({ error: error.response.data.detail });
        this.showErrorMsg({
          message: error.response.data.detail
        });
      }
    },

    closeTable() {
      window.location.href = "/onboarding/lo";
    },

    showChoiceFunc() {
      this.showChoice = true;
    },

    flutterwavePaygate(amount) {
      if (amount === "10") this.processCard = true;
      let finalAmount = this.processCard
        ? amount
        : this.firstpaymentamt
        ? this.firstpaymentamt
        : this.getCustomerProductOptions.firstpaymentamt;

      FlutterwaveCheckout({
        public_key: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
        tx_ref: this.genRandomNumber,
        amount: finalAmount,
        // amount: "10",
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        redirect_url: "/onboarding/lo?goto=lo_finish",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a"
        },
        customer: {
          email: this.getUserSession.email,
          phone_number: this.getUserSession.phonenumber,
          name:
            this.getUserSession.firstname + " " + this.getUserSession.lastname
        },
        payment_options: "card, ussd",
        callback: function(data) {
          console.log("flutterwaveCheckout", data);
        },
        onclose: function(data) {
          // close modal
          console.log("on close", data);
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo:
            "https://arnergy.com/wp-content/uploads/2021/09/arnergy-logo.png"
        }
      });
    },

    async consent(answer) {
      this.debitCards.map(card => {
        if (card.isDefaultCard) this.defaultCardID = card.id;
      });

      const onboardingData = {
        customerid: this.getUserSession.id,
        productid: this.custProdOptions.productid,
        customerconcent: answer,
        id: this.defaultCardID
      };

      if (answer === "Y") {
        this.loader = true;

        const HTTP = this.$httpUtils.FASTHTTP;
        this.showChoice = false;

        try {
          this.$emit("showLoading", true);
          let res = await HTTP.post(
            "/payment/update-recurring",
            onboardingData
          );

          if (res.data) {
            this.loader = false;

            this.$emit("showLoading", false);
            this.$emit("updateStatus");
            return;
          }
        } catch (error) {
          this.$emit("showLoading", false);
          this.loader = false;
          console.log({ error: error.response.data.error.message });
          this.showErrorMsg({
            message: error.response.data.detail
          });
        }
      } else {
        this.showChoice = false;
      }
    },

    fetchAmt(id) {
      const HTTP = this.$httpUtils.FASTHTTP;

      HTTP.get(`/productoption/productoption`)
        .then(res => {
          console.log("This is the dataaa", res.data);
          this.custProdOptions = res.data;
          this.firstpaymentamt = res.data.firstpaymentamt; //change this...
        })
        .catch(err => console.log(err));

      this.$forceUpdate();
    },

    fetchDebitCards(id) {
      this.counter = this.counter + 1;
      console.log("counter: ", this.counter);
      const HTTP = this.$httpUtils.FASTHTTP;

      HTTP.get(`/payment/get-cards`)
        .then(res => {
          console.log("fetchDebit", res.data);
          this.debitCards = res.data;
          if (this.debitCards.length > 0) {
            this.activeIndex = 1;
            this.markAsCompleted(true);
          }
          if (
            this.debitCards.length === 1 &&
            !this.debitCards[0].isDefaultCard
          ) {
            const card = this.debitCards[0];
            // this.setDefaultCard(card.id, card.customerid);
            // this.fetchDebitCards(this.getUserSession.id);
          }
        })
        .catch(error => console.log(error));
    },

    setDefaultCard(cardid, custid) {
      const HTTP = this.$httpUtils.FASTHTTP;
      const data = { id: cardid, customerid: custid };
      console.log("setDefa", data);

      HTTP.post("/payment/set-default-cards", data)
        .then(res => {
          this.processCard = true;
          this.defaultCardSet = true;
          this.showSuccessMsg({ message: "Default card set successfully!" });
          this.fetchDebitCards(this.getUserSession.id);
          this.defaultCardID = cardid;
        })
        .catch(error => {
          this.loader = false;
          console.log({ error: error.response.data.detail });
          this.showErrorMsg({
            message: error.response.data.detail
          });
        });
      console.log("debitt", this.debitCards);
    },

    setActiveIndex(id) {
      const HTTP = this.$httpUtils.FASTHTTP;

      HTTP.get("/onboardingstate/state")
        .then(response => {
          console.log("setActive", response.data);
          if (response.data.stateid == 8) {
            this.activeIndex = 1;
            return;
          }
        })
        .catch(error => {
          console.log({ error });
        });
    }
  },
  async mounted() {
    console.log("mounted");
    await this.fetchAmt(this.getUserSession.id);

    this.fetchDebitCards(this.getUserSession.id);

    this.setActiveIndex(this.getUserSession.id);

    this.setCurrentAfterPayment();
    this.updateTracker(true);
    this.updateStatus(5);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

h3 {
  font-weight: 700;
  font-size: 16px;
  color: #000000;
  margin: 20px 0px;
}

h4 {
  font-weight: 700;
  font-size: 16px;
  color: #fe7a11;
  margin: 13px 0px;
}

.amount {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #000000;
}

.summary-container {
  display: flex;
  justify-content: space-between;
}

.download-button {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  display: flex;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-top: 35px;
  margin-right: 35px;
  cursor: pointer;
}

.summary {
  width: 664px;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;
    width: 70%;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 24px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p:last-child {
        text-align: right;
        width: 50%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .table-base p {
      font-weight: bold;
    }
  }
}

.kyc-row {
  display: flex;
  width: 664px;
  flex-direction: row;
  justify-content: space-between;
}

.first {
  width: 49%;
}

.card-section {
  display: flex;
  flex-direction: column;
  width: 800px;
}

.debit-cards {
  width: 425px;
  padding: 36px 55px;
  background: #0892d0;
  border: 1px solid #0892d0;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 13px 0px;
  cursor: pointer;

  p {
    color: #ffffff;
  }

  h2 {
    color: #ffffff;
    margin: 5px 0px;
    font-size: 24px;
    font-weight: 700;
  }
}

.debit-cards-inactive {
  width: 425px;
  padding: 36px 55px;
  border: 1px solid #efefef;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 13px 0px;
  cursor: pointer;

  p {
    color: #000000;
  }

  h2 {
    color: #000000;
    margin: 5px 0px;
    font-size: 24px;
    font-weight: 700;
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;
  margin-top: -20rem;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/PayDeposit.vue